export enum TextoMidiaEnum {

  TEXTO = "Texto",
  MIDIA = "Mídia"

}
